// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 8702 ? "a6ae8d82" : chunkId) + "." + {"2586":"b0630ef326e83a54","4676":"ab745297d6dd2457","5811":"9de2383fa89486ce","8702":"dac4ea4089fabede"}[chunkId] + ".js";
};